import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "new4",
  "use": "new4-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"new4\"><defs><style>#new4 .cls-1{fill:none}</style></defs><title>Group 148 (2)</title><g id=\"new4_图层_2\" data-name=\"图层 2\"><g id=\"new4_图层_1-2\" data-name=\"图层 1\"><g id=\"new4_Group_148\" data-name=\"Group 148\"><path id=\"new4_Rectangle_45_Copy_13\" data-name=\"Rectangle 45 Copy 13\" class=\"cls-1\" d=\"M0 0h24v24H0z\" /><g id=\"new4_bells\"><path id=\"new4_Shape\" d=\"M12 24a1.69 1.69 0 0 1-1.69-1.69v-1.12H3.84a.85.85 0 0 1 0-1.69h.66V9a7.48 7.48 0 0 1 6.66-7.45v-.7a.84.84 0 1 1 1.68 0v.7A7.48 7.48 0 0 1 19.5 9v10.5h.66a.85.85 0 0 1 0 1.69h-6.47v1.12A1.69 1.69 0 0 1 12 24zm0-20.81A5.81 5.81 0 0 0 6.19 9v10.5h11.62V9A5.81 5.81 0 0 0 12 3.19z\" /></g></g></g></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/common/new4.svg
// module id = yXMO
// module chunks = 6